/** Permissions that mean the user is staff (junior operator or admin). */
export const STAFF_PERMISSIONS = ['*', 'content.admin', 'analytics.read', 'users.admin'] as const;

export function can(permissions: readonly string[] | undefined, permission: string): boolean {
  if (!permissions) return false;
  return permissions.includes('*') || permissions.includes(permission);
}

export function isStaffFromPermissions(permissions: readonly string[] | undefined): boolean {
  if (!permissions) return false;
  return STAFF_PERMISSIONS.some((slug) => permissions.includes(slug));
}

export function roleLabel(slug: string): string {
  if (slug === 'admin') return 'Admin';
  if (slug === 'teacher') return 'Teacher';
  if (slug === 'student') return 'Student';
  return slug;
}
